/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Component } from "@angular/core";
import { LoadingListener } from "../../utils/loading/loading-listener";
var LoadingButton = (function () {
    function LoadingButton() {
    }
    LoadingButton.prototype.startLoading = function () {
        this.loading = true;
    };
    LoadingButton.prototype.doneLoading = function () {
        this.loading = false;
    };
    return LoadingButton;
}());
export { LoadingButton };
LoadingButton.decorators = [
    { type: Component, args: [{
                selector: "button[clrLoading]",
                template: "\n        <span class=\"spinner spinner-inline\" *ngIf=\"loading\"></span>\n        <ng-content></ng-content>\n    ",
                providers: [{ provide: LoadingListener, useExisting: LoadingButton }]
            },] },
];
/** @nocollapse */
LoadingButton.ctorParameters = function () { return []; };
//# sourceMappingURL=loading-button.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/button/button-loading/loading-button.js
// module id = 282
// module chunks = 4